import { render } from "./rechargeDetail.vue?vue&type=template&id=50ffc471&scoped=true"
import script from "./rechargeDetail.vue?vue&type=script&lang=js"
export * from "./rechargeDetail.vue?vue&type=script&lang=js"

import "./rechargeDetail.vue?vue&type=style&index=0&id=50ffc471&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ffc471"],['__file',"src/views/my/rechargeDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50ffc471"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50ffc471', __exports__)) {
    console.log('reload')
    api.reload('50ffc471', __exports__)
  }
  
  module.hot.accept("./rechargeDetail.vue?vue&type=template&id=50ffc471&scoped=true", () => {
    console.log('re-render')
    api.rerender('50ffc471', render)
  })

}


export default __exports__